export default "__VITE_ASSET__B8Fh5Nyv__"